import type { ProductsStateResolver, UnifiedOffer } from '../SelectProductsModal.types'

export const getProductsStates = (
  resolver: ProductsStateResolver | undefined,
  products?: UnifiedOffer[],
) => products?.reduce((prev, current) => ({ ...prev, [current.id]: resolver?.(current) }), {}) || {}
